import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { RecipientsApi } from '@shared/api/rest';
import type { RecipientResponse } from '@shared/api/rest/recipients';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const effect = createEffect((params: IQueryParams<string>) => RecipientsApi.getById(params.request, params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<RecipientResponse | null>(null)
  .on(effect.done, (current, data) => data.result ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, () => false)
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => ApiUtils.errorStoreActionForbiddenWatcher(x, $notificationStore.events.setError));

export const $recipientByIdStore = {
  events: {
    getById: ApiUtils.wrapperApi(effect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
